import { achievementSnapshotDisplay } from '../../../../shared/models/staff-achievement.model';
import { WeightedSnapshotDisplay, weightedSnapshotDisplay } from '../../../../shared/models/staff-weighted-work-snapshot';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');

@Component({
  selector: 'app-staff-performance-metrics-saved-dashboard',
  templateUrl: './staff-performance-metrics-saved-dashboard.component.html',
  styleUrls: ['./staff-performance-metrics-saved-dashboard.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService]
})
export class StaffPerformanceMetricsSavedDashboardComponent implements OnInit {
  weightedSnapshots: WeightedSnapshotDisplay[] = [];
  achievementSnapshots: Array<ReturnType<typeof achievementSnapshotDisplay>> = [];
  private weightedSelectionGeneration = 0;

  
     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;
  users: Object;
  users_staff: any;
  saved_staff_metric_file_data: Object;

  // files and filtering
  savedFilesList: Array<{ text: string; value: string }> = []; // Dropdown data source
  selectedFiles: string[] = []; // Stores selected file names
  
  // Fields mapping for MultiSelect
  multiSelectFields: Object = { text: 'text', value: 'value' };
  logs_search_kPI_benchmarks_global: any[];
  created_by_count_array_data: any[];
  all_items_count_array_data: any[];
  logs_search_kPI_benchmarks_global_GRID_count: any;
  all_items_count_array_data_count: any;
// Variable to hold the search model data from each file
search_model_data: any[] = [];
  search_model: SystemLog;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public service: DataService,
    //  private orderService: WoocommerceOrderService,
     public sanitizer: DomSanitizer, // https://stackblitz.com/edit/angular-iframe-src-ae7kkf?file=src%2Fapp%2Fapp.component.ts
  ) { }

  ngOnInit(): void {

    this.search_model = new SystemLog(); // if undefined need to setup the model first.

    this.loadSavedFiles();
    // this.getUsers()
  }





// Load saved JSON files
loadSavedFiles() {
  this._demoService.getSavedStaffMetricsDataFile().subscribe(
    (data: string[]) => {
      this.savedFilesList = data.map((fileName) => ({
        text: this.formatFileName(fileName), // Display-friendly name
        value: fileName, // Actual file name for selection
      }));
    },
    (err) => console.error(err)
  );
}

// Format file name for display
formatFileName(fileName: string): string {
  return fileName.replace('.json', '');
}

// Handle file selection change
onFileSelectionChange(event: any) {
  this.selectedFiles = event.value; // Update selected files
  this.loadDataForSelectedFiles();
}

// Custom filtering logic for full-text search
onFiltering(e: FilteringEventArgs) {
  const query = e.text.toLowerCase();
  e.updateData(
    this.savedFilesList.filter((item) =>
      item.text.toLowerCase().includes(query)
    )
  );
}

// loadDataForSelectedFiles() {
//   if (this.selectedFiles.length === 0) return;

//   this._demoService.getSelectedStaffMetricsDataFiles(this.selectedFiles).subscribe(
//     (data: any[]) => {
//       // Clear existing data arrays
//       this.logs_search_kPI_benchmarks_global = [];
//       this.created_by_count_array_data = [];
//       this.all_items_count_array_data = [];

//       // Load data for each selected file
//       data.forEach((fileData: any) => {
//         if (fileData.logs_search_kPI_benchmarks_global) {
//           this.logs_search_kPI_benchmarks_global.push(...fileData.logs_search_kPI_benchmarks_global);
//         }
//         if (fileData.created_by_count_array_data) {
//           this.created_by_count_array_data.push(...fileData.created_by_count_array_data);
//         }
//         if (fileData.all_items_count_array_data) {
//           this.all_items_count_array_data.push(...fileData.all_items_count_array_data);
//         }
//       });

//       // Update UI counts
//       this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global.length;
//       this.all_items_count_array_data_count = this.all_items_count_array_data.length;

//       console.log("Logs KPI Benchmarks Global:", this.logs_search_kPI_benchmarks_global);
//       console.log("Created By Count Array Data:", this.created_by_count_array_data);
//       console.log("All Items Count Array Data:", this.all_items_count_array_data);
//     },
//     (err) => {
//       console.error("Error loading selected metrics:", err);
//     }
//   );
// }


loadDataForSelectedFiles() {
  const weightedGeneration = ++this.weightedSelectionGeneration;
  this.weightedSnapshots = [];
  this.achievementSnapshots = [];
  const weightedFileNames = [...this.selectedFiles];
  if (this.selectedFiles.length === 0) return;

  this._demoService.getSelectedStaffMetricsDataFiles(this.selectedFiles).subscribe(
    (data: any[]) => {
      if (weightedGeneration === this.weightedSelectionGeneration) {
        this.weightedSnapshots = data.map((file: any, index: number) => weightedSnapshotDisplay(file, weightedFileNames[index]));
        this.achievementSnapshots = data.map((file: any, index: number) => achievementSnapshotDisplay(file, weightedFileNames[index]));
      }
      // Reset existing arrays
      this.logs_search_kPI_benchmarks_global = [];
      this.created_by_count_array_data = [];
      this.all_items_count_array_data = [];
      this.search_model_data = [];

      data.forEach((fileData: any) => {
        if (fileData && fileData.data) {
          // Process indexed entries (like "0", "1", etc.)
          for (let key in fileData.data[0]) {
            if (!isNaN(parseInt(key))) {
              this.logs_search_kPI_benchmarks_global.push(fileData.data[0][key]);
            } else {
              // Handle named entries separately (e.g., "user_login", "job_created")
              if (fileData.data[0][key]) {
                this.logs_search_kPI_benchmarks_global.push(fileData.data[0][key]);
              }
            }
          }
          // Similar parsing for created_by_count_array_data and all_items_count_array_data
          if (fileData.data[1]) {
            for (let key in fileData.data[1]) {
              this.created_by_count_array_data.push(fileData.data[1][key]);
            }
          }
          if (fileData.data[2]) {
            this.all_items_count_array_data.push(...fileData.data[2]);
          }

          // Collect search model information if present
          if (fileData.search_model) {
            this.search_model_data.push(fileData.search_model);
            this.search_model = {
                  ...fileData.search_model
                }
          }
        }
      });

      // Update UI counts
      this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global.length;
      this.all_items_count_array_data_count = this.all_items_count_array_data.length;

      console.log("Logs KPI Benchmarks Global:", this.logs_search_kPI_benchmarks_global);
      console.log("Created By Count Array Data:", this.created_by_count_array_data);
      console.log("All Items Count Array Data:", this.all_items_count_array_data);
      console.log("Search Model Data:", this.search_model_data);
    },
    (err) => console.error("Error loading selected metrics:", err)
  );
}



// loadDataForSelectedFiles() {
//   if (this.selectedFiles.length === 0) return;
//   const colorPalette = ['#FF5733', '#33FF57', '#3357FF', '#F033FF', '#33FFF6'];

//   this._demoService.getSelectedStaffMetricsDataFiles(this.selectedFiles).subscribe(
//     (data: any[]) => {
//       // Initialize arrays for separate data series
//       this.logs_search_kPI_benchmarks_global = [];
//       this.created_by_count_array_data = [];
//       this.all_items_count_array_data = [];
//       this.search_model_data = [];

//       // Loop through each file's data and use filename as label
//       data.forEach((fileData: any, index) => {
//         const fileName = this.selectedFiles[index].replace('.json', ''); // Remove .json for cleaner label


//         if (fileData && fileData.data) {
//           // Separate series for each file with filename as label
//           this.logs_search_kPI_benchmarks_global.push({
//             label: fileName,
//             data: Object.values(fileData.data[0] || {})
//           });

//           this.created_by_count_array_data.push({
//             label: fileName,
//             data: Object.values(fileData.data[1] || {})
//           });

//           this.all_items_count_array_data.push({
//             label: fileName,
//             data: fileData.data[2] || []
//           });

//           // Collect search model data, also labeled by filename
//           this.search_model_data.push({
//             label: fileName,
//             model: fileData.search_model || {}
//           });
//           this.search_model = {
//             ...fileData.search_model
//           }
//         }
//       });

//       // UI Counts for each series
//       this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global.flatMap(file => file.data).length;
//       this.all_items_count_array_data_count = this.all_items_count_array_data.flatMap(file => file.data).length;

//       // Log results for verification
//       console.log("Logs KPI Benchmarks Global Series:", this.logs_search_kPI_benchmarks_global);
//       console.log("Created By Count Array Data Series:", this.created_by_count_array_data);
//       console.log("All Items Count Array Data Series:", this.all_items_count_array_data);
//       console.log("Search Model Data Series:", this.search_model_data);
//     },
//     (err) => console.error("Error loading selected metrics:", err)
//   );
// }




  
getUsers() {
  this._demoService.getUsers().subscribe(
     data => { 
      this.users = data;
  
      // TODO
      // simple loadash to map only staff members.
      let count_of_items = Object.keys(this.users).length;
  
  this.users_staff = [];
  
      for (let i = 0; i < count_of_items; i++) {
  
   if(this.users[i].access_level <= 4){
    this.users_staff.push({
      ...this.users[i]
    })
   }
   this.users_staff = this.users_staff;
  }
  
  
  
      },
     err => console.error(err),
     () => console.log('done loading users')
   );
  }



  // getSavedStaffMetricsDataFile() {
  //   this._demoService.getSavedStaffMetricsDataFile().subscribe(
  //      data => { this.saved_staff_metric_file_data = data;
  //       console.log(data);
  //    },
  //      err => console.error(err),
  //      () => console.log('done loading saved metrics')
  //    );
  //  }

  // Load selected files' data
  getSavedStaffMetricsDataFile() {
    this._demoService.getSavedStaffMetricsDataFile().subscribe(
      (data: any[]) => {
        console.log("Full API response:", data); // Log the entire response
  
        // Clear existing arrays to avoid data duplication
        this.logs_search_kPI_benchmarks_global = [];
        this.created_by_count_array_data = [];
        this.all_items_count_array_data = [];
        this.search_model_data = []; // Reset the search model data array
  
        data.forEach((fileData: any, index) => {
          console.log(`Processing File [${index}]:`, fileData);
  
          // Ensure fileData and its fields exist before accessing them
          if (fileData && fileData.data && fileData.search_model) {
            // Add search model to the array
            this.search_model_data.push(fileData.search_model);
            console.log(`Search Model for File [${index}]:`, fileData.search_model);
  
            const fileContent = fileData.data;
  
            // Logs Search KPI Benchmarks Global
            if (fileContent[0]) {
              console.log(`File [${index}] - Logs Search KPI Benchmarks Global:`, fileContent[0]);
              Object.keys(fileContent[0]).forEach((key) => {
                this.logs_search_kPI_benchmarks_global.push(fileContent[0][key]);
              });
            } else {
              console.warn(`File [${index}] missing 'logs_search_kPI_benchmarks_global' data.`);
            }
  
            // Created By Count Array Data
            if (fileContent[1]) {
              console.log(`File [${index}] - Created By Count Array Data:`, fileContent[1]);
              Object.keys(fileContent[1]).forEach((key) => {
                this.created_by_count_array_data.push(fileContent[1][key]);
              });
            } else {
              console.warn(`File [${index}] missing 'created_by_count_array_data'.`);
            }
  
            // All Items Count Array Data
            if (fileContent[2]) {
              console.log(`File [${index}] - All Items Count Array Data:`, fileContent[2]);
              this.all_items_count_array_data.push(...fileContent[2]);
            } else {
              console.warn(`File [${index}] missing 'all_items_count_array_data'.`);
            }
          } else {
            console.warn(`File [${index}] missing 'data' or 'search_model' structure`, fileData);
          }
        });
  
        // Calculate counts for UI display
        this.logs_search_kPI_benchmarks_global_GRID_count = this.logs_search_kPI_benchmarks_global.length;
        this.all_items_count_array_data_count = this.all_items_count_array_data.length;
  
        // Final log summaries
        console.log("Logs KPI Benchmarks Global:", this.logs_search_kPI_benchmarks_global);
        console.log("Created By Count Array Data:", this.created_by_count_array_data);
        console.log("All Items Count Array Data:", this.all_items_count_array_data);
        console.log("Search Model Data:", this.search_model_data);
      },
      (err) => {
        console.error("Error loading saved metrics:", err);
      },
      () => {
        console.log("Done loading saved metrics");
      }
    );
  }
  


}